export const AJNA_POOL_INFO_UTILS_ABI = [
  {
    type: "function",
    name: "poolPricesInfo",
    inputs: [{ name: "ajnaPool_", type: "address" }],
    outputs: [
      { name: "hpb_",      type: "uint256" },
      { name: "hpbIndex_", type: "uint256" },
      { name: "htp_",      type: "uint256" },
      { name: "htpIndex_", type: "uint256" },
      { name: "lup_",      type: "uint256" },
      { name: "lupIndex_", type: "uint256" },
    ],
    stateMutability: "view",
  },
] as const;
